export default __webpack_public_path__ + "static/media/goatbg.d8026fe0.svg";